import React, {memo} from 'react';
import PropTypes from 'prop-types';

export const  InfoIcon = memo(({ fillColor = '#555555', width = 24, height = 24 }) =>
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7Z' fill={fillColor} />
    </svg>
);

InfoIcon.displayName = 'InfoIcon';

InfoIcon.propTypes = {
    fillColor: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
};
